import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';

import BodyList from '../../components/body/list';
import Framework from '../../components/framework';
import Breadcrumb from '../../components/framework/breadcrumb';
import PageHeader from '../../components/framework/pages/page-header';
import useTranslation from '../../hooks/use_translation';

const Body = ({ location }) => {
	const { t } = useTranslation('body');

	return (
		<Framework
			description={t('meta_description')}
			location={location}
			tags={t('meta_keywords')}
			title={t('title')}
		>
			<section id="content">
				<div className="container px-0 mt-lg-3 mt-2">
					<nav aria-label="breadcrumb">
						<Breadcrumb
							className=""
							fact={true}
							links={[{ active: true, title: t('t1') }]}
						/>
					</nav>
				</div>
			</section>
			<div className="container">
				<PageHeader
					excerpt={t('t2')}
					pageVariant="nested_page"
					title={t('t1')}
				/>

				<div className="mt-3">
					<BodyList />
				</div>
			</div>
		</Framework>
	);
};

Body.propTypes = {
	location: PropTypes.object.isRequired,
};

export default Body;

export const query = graphql`
	query {
		locales: allLocale {
			...translationFields
		}
	}
`;
